<template>
    <v-col
        :cols="cols">
        <div
            class="subtitle-2 pb-2 font-weight-bold"
            v-html="proccessedLabel"/>

        <component
            v-model="itemValue"
            v-bind="$attrs"
            v-on="$listeners"
            label=""
            :type="type"
            :is="formComponent"/>
    </v-col>
</template>

<script>
import TextField from '@/components/fields/TextField'
import TextAreaField from '@/components/fields/TextAreaField'
import SelectField from '@/components/fields/SelectField'
import GeolocationField from '@/components/fields/GeolocationField'
import DateRangeField from '@/components/fields/DateRangeField'
import DateTimeRangeField from '@/components/fields/DateTimeRangeField'
import DateField from '@/components/fields/DateField'
import TimeRangeField from '@/components/fields/TimeRangeField'
import FileUploadField from '@/components/fields/FileUploadField'

export default {
    name: 'DetailFormItem',

    inheritAttrs: false,

    props: {
        value: {
            required: true
        },

        cols: {
            type: String,
            default: '12'
        },

        type: {
            type: String,
            default: 'text'
        },

        label: {
            type: String,
            default: ''
        },

        required: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        formComponent () {
            switch (this.type) {
                case 'text':
                case 'number':
                    return TextField
                case 'textarea':
                    return TextAreaField
                case 'select':
                case 'selectRelation':
                    return SelectField
                case 'date':
                    return DateField
                case 'dateRange':
                    return DateRangeField
                case 'timeRange':
                    return TimeRangeField
                case 'dateTimeRange':
                    return DateTimeRangeField
                case 'geolocation':
                    return GeolocationField
                case 'file':
                    return FileUploadField
                case 'none':
                    return ''
            }

            return TextField
        },

        proccessedLabel () {
            const requireSymbol = this.$t('required')
            return this.required ? `${this.label} ${requireSymbol}` : this.label
        },

        itemValue: {
            get () {
                return this.value
            },

            set (value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
